'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'flask-round-potion';
var width = 384;
var height = 512;
var aliases = ["flask-potion"];
var unicode = 'f6e1';
var svgPathData = 'M296 0l-216 0 0 16 32 0 0 129.4C45.9 175.7 0 242.5 0 320 0 426 86 512 192 512s192-86 192-192c0-77.5-45.9-144.3-112-174.6l0-129.4 32 0 0-16-8 0zM128 150.6l0-134.6 128 0 0 139.9 4.9 2.1c63 26.8 107.1 89.3 107.1 162 0 5.4-.2 10.7-.7 16l-60.1 0c-31.3 0-61.8-10.7-86.2-30.2-27.3-21.8-61.2-33.8-96.2-33.8l-1.6 0c-29.7 0-58.8 8.4-84 24.1L16.3 310.4C19.9 241.8 62.9 183.6 123.1 158l4.9-2.1 0-5.3zM16.2 329.3l4-2.5 27.4-17.1C70.3 295.5 96.5 288 123.2 288l1.6 0c31.3 0 61.8 10.7 86.2 30.2 27.3 21.8 61.2 33.8 96.2 33.8l57.9 0c-15 81.9-86.8 144-173.1 144-94.1 0-170.9-73.8-175.8-166.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlaskRoundPotion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;